import * as moment from 'moment';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

export const member_c9 = 'APP_KPI_C9';
export const admin_c9 = 'ADMIN_KPI_C9';

export const checkIsAdmin = (userRoles) => {
    if (!userRoles || !Array.isArray(userRoles)) return false;
    return userRoles.some(r => {
        const lowerR = String(r).toLowerCase();
        return lowerR === 'admin' || lowerR === admin_c9.toLowerCase();
    });
};

export const checkIsMemberC9 = (roles) => {
    if (!roles || !Array.isArray(roles)) return false;
    return roles.some(r => {
        const roleName = typeof r === 'string' ? r : (r.name || r.Name || '');
        return roleName === member_c9;
    });
};

export const titleStatisticWebPage = "CNTT 108 viện 108";

export const DATE_TIME_REACT_FORMAT = 'dd/MM/yyyy HH:mm';
export const DATE_TIME_REACT_FORMAT_TYPE_ONE = 'DD/MM/YYYY HH:mm';
export const DATE_TIME_REACT_WITHOUT_HOUR_FORMAT = 'dd/MM/yyyy';
export const DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT = 'DD/MM/YYYY';
export const ID_EMPTY = '00000000-0000-0000-0000-000000000000';
export const EXTRAORDINARY_JOB_GROUP_NAME = 'Nhiệm vụ đột xuất';
export const extraordinary_job_group_name = EXTRAORDINARY_JOB_GROUP_NAME;

export const timeStep = 15;
export const TOKEN_KEY = 'auth_auth_server_cntt_108';
export const ID_TOKEN_KEY = 'auth_identity_auth_server_cntt_108';
export const REFRESH_TOKEN_KEY = 'auth_refresh_token_auth_server_cntt_108';
export const EXPIRY_KEY = 'auth_expire_auth_server_cntt_108';
export const FLASH_KEY = 'flash';
export const CRAWLER_SLUGNAME = 'baogia_tnh99';
export const acceptImage = 'image/png,image/jpg,image/jpeg,image/gif';
export const acceptDoc = 'image/png,image/jpg,image/jpeg,image/gif,application/pdf';
export const acceptZip = 'application/zip';
export const acceptVideo = 'video/mp4,video/x-m4v,video/*';
export const status200 = 200;
export const status201 = 201;
export const status400 = 400;

// export let refreshingPromise = null;

export const levelMessage = {
  error: 'error',
  info: 'info',
  warning: 'warning',
  success: 'success'
};

export const postStatus = {
  all: '',
  release: 'release',
  draft: 'draft',
  pending: 'pending',
  refuse: 'refuse'
};

export const dataChoosePlantProcedure = {
  all: 'all',
  choose: 'choose',
};

export const objectDataChoosePlantProcedure = [
  { label: 'Tất cả', value: dataChoosePlantProcedure.all },
  { label: 'Đã chọn quy trình', value: dataChoosePlantProcedure.choose },
];


export const dataOSSystem = {
  ios: 'ios',
  android: 'android',
};

export const sentenceType = {
  noChoose: 'noChoose',
  firstQuestion: 'firstQuestion',
  endedQuestion: 'endedQuestion',
  guidedSentence: 'guidedSentence',
  secondToEndQuestion: 'secondToEndQuestion',
};

export const objectSentenceType = [
  { label: 'Không chọn', value: sentenceType.noChoose },
  { label: 'Câu hỏi đầu tiên', value: sentenceType.firstQuestion },
  { label: 'Câu hỏi cuối cùng', value: sentenceType.endedQuestion },
  { label: 'Câu hỏi thứ 2 gần cuối', value: sentenceType.secondToEndQuestion },
  { label: 'Câu hướng dẫn', value: sentenceType.guidedSentence },
];

export const answerChoice = {
  noChoose: 'noChoose',
  yesChoice: 'yesChoice',
  noChoice: 'noChoice',
};

export const objectAnswerChoice = [
  { label: 'Không chọn', value: answerChoice.noChoose },
  { label: 'Có', value: answerChoice.yesChoice },
  { label: 'Không', value: answerChoice.noChoice },
];

export const accountGender = {
  male: 'male',
  female: 'female',
  other: 'other',
};

export const objectAccountGender = [
  { label: 'Nam', value: accountGender.male },
  { label: 'Nữ', value: accountGender.female },
  { label: 'Khác', value: accountGender.other },
];

export const typeQA = {
  question: 'question',
  answer: 'answer',
};

export const objectTypeQA = [
  { label: 'Câu hỏi', value: typeQA.question },
  { label: 'Câu trả lời', value: typeQA.answer },
];

export const trangThaiDeNghiValue = {
  chuaXuLy: 'chuaXuLy',
  dangXuLy: 'dangXuLy',
  daXuLy: 'daXuLy',
  all: 'all'
};

export const objectTrangThaiDeNghi = [
  { label: 'Tất cả', value: trangThaiDeNghiValue.all },
  { label: 'Chưa xử lý', value: trangThaiDeNghiValue.chuaXuLy },
  { label: 'Đang xử lý', value: trangThaiDeNghiValue.dangXuLy },
  { label: 'Đã xử lý', value: trangThaiDeNghiValue.daXuLy },
];

export const loaiNoiDungValue = {
  noidungdenghi: 'noidungdenghi',
  chinhsuabaohiem: 'chinhsuabaohiem',
  all: 'all'
};

export const objectLoaiNoiDung = [
  { label: 'Tất cả', value: loaiNoiDungValue.all },
  { label: 'Nội dung đề nghị', value: loaiNoiDungValue.noidungdenghi },
  { label: 'Chỉnh sửa bảo hiểm', value: loaiNoiDungValue.chinhsuabaohiem },
];

export const loai = {
  them: 'them',
  sua: 'sua',
  xoa: 'xoa',
  chon: 'chon',
  koChon: 'koChon',
};

export const objectLoai = [
  { label: 'Thêm', value: loai.them },
  { label: 'Sửa', value: loai.sua },
  { label: 'Xoá', value: loai.xoa },
  { label: 'Chọn', value: loai.chon },
  { label: 'Không chọn', value: loai.koChon },
];

export const loaiXuLy = {
  tuXuLy: 'tuXuLy',
  doiTacXuLy: 'doiTacXuLy',
  koChon: 'koChon',
};

export const objectLoaiXuLy = [
  { label: 'Tự xử lý', value: loaiXuLy.tuXuLy },
  { label: 'Đối tác xử lý', value: loaiXuLy.doiTacXuLy },
  { label: 'Không chọn', value: loai.koChon },
];

export const sortByValue = {
  ngayDeNghi: 'ngayDeNghi',
  tienChenhLech: 'tienChenhLech',
  tienBaoHiem: 'tienBaoHiem',
};

export const objectDataOSSystem = [
  { label: 'IOS', value: dataOSSystem.ios },
  { label: 'Android', value: dataOSSystem.android },
];

export const objectFertilizerComponent = [
  { label: 'N', value: "n" },
  { label: 'P', value: "p" },
  { label: 'K', value: "k" },
  { label: 'Đạm', value: "protein" },
  { label: '1% đến 20%', value: "rangeFirst" },
  { label: '20% đến 40%', value: "rangeSecond" },
  { label: '40% đến 60%', value: "rangeThird" },
  { label: '60% đến 80%', value: "rangeFourth" },
  { label: '80% đến 100%', value: "rangeFifth" }
];

export const objectStatusPost = [
  { label: 'Tất cả', value: postStatus.all },
  { label: 'Đã duyệt', value: postStatus.release },
  { label: 'Bản nháp', value: postStatus.draft },
  { label: 'Chờ duyệt', value: postStatus.pending },
  { label: 'Từ chối', value: postStatus.refuse }
];

export const dataTypeCategory = {
  all: '',
  information: 'information',
  video: 'video',
  image: 'image',
  introduce: 'introduce'
};

export const objectDataTypeCategory = [
  { label: 'Danh sách tin tức', value: dataTypeCategory.information },
  { label: 'Danh sách video', value: dataTypeCategory.video },
  { label: 'Danh sách ảnh', value: dataTypeCategory.image },
  { label: 'Giới thiệu', value: dataTypeCategory.introduce },
];

export const dataTypeVideo = {
  none: 'none',
  all: "all",
  program: "program",
  tvc: "tvc",
  qc: "qc",
};
export const objectDataTypeVideo = [
  { label: 'Không phải video', value: dataTypeVideo.none },
  { label: 'Video', value: dataTypeVideo.all },
  { label: 'Video Chương trình', value: dataTypeVideo.program },
  { label: 'Video Doanh nghiệp', value: dataTypeVideo.tvc },
  { label: 'Video Quảng Cáo', value: dataTypeVideo.qc },
];

export const objectShowNumber = [
  { text: '5', value: 5 },
  { text: '20', value: 20 },
  { text: '50', value: 50 },
  { text: '100', value: 100 }
];

export const reportPost = {
  ByStatus: 'ByStatus',
  ByCreatedDate: 'ByCreatedDate',
  ByPublicDate: 'ByPublicDate',
  DataType: 'DataType',
  Author: 'Author',
  Category: 'Category'
};
export const reportAdvertisingAnalysis = {
  ByImageThumb: 'ByImageThumb',
  ByDate: 'ByDate',
  ByCategoryId: 'ByCategoryId',
};
export const objectReportAdvertisingAnalysis = [
  { text: 'Link quảng cáo', value: reportAdvertisingAnalysis.ByImageThumb },
  { text: 'Ngày ', value: reportAdvertisingAnalysis.ByDate },
  { text: 'Danh mục', value: reportAdvertisingAnalysis.ByCategoryId },
];


export const objectReportPost = [
  { text: 'Trạng thái', value: reportPost.ByStatus },
  { text: 'Ngày tạo', value: reportPost.ByCreatedDate },
  { text: 'Ngày xuất bản', value: reportPost.ByPublicDate },
  { text: 'Loại', value: reportPost.DataType },
  { text: 'Người tạo', value: reportPost.Author },
  { text: 'Danh mục', value: reportPost.Category },
];
export const objectStatusCrawl = [
  { text: 'Tất cả', value: '' },
  { text: 'Đã duyệt', value: 'active' }
];

export const objectTypeInput = [
  { text: 'Text', value: 'text' },
  { text: 'Html', value: 'html' }
];

export const role = {
  Admin: 'admin',
  Manager: 'manager',
  Publisher: 'publisher',
  Editor: 'editor',
  Booker: 'booker',
  Approver: 'approver',
  General: 'general',

  XemBaoCao: "xembaocao"
};
export const objectRoles = [
  { label: 'Admin', value: role.Admin },
  { label: 'Người thêm và sửa', value: role.Editor },
  { label: 'Quyền xem báo cáo', value: role.XemBaoCao },
  // { label: 'Người phê duyệt', value: role.Approver },
  // { label: 'Người quản lý trang thiết bị', value: role.Manager }
];

export const positionBanner = [
  { label: 'Bên trái', value: 'left' },
  { label: 'Bên phải', value: 'right' },
  { label: 'Trên cùng', value: 'top' },
  { label: 'Phía dưới', value: 'bottom' }
];
export const typeBanner = [
  { value: '1', label: 'Banner ngang' },
  { value: '0', label: 'Banner dọc' }
];

export const typeError = {
  UserName: 'UserName',
  Email: 'Email',
  Code: 'Code'
};

export const messageError = {
  emptyMessage: 'Trường dữ liệu không được để trống',
  emailMessage: 'Địa chỉ email không chính xác',
  minLength6Message: 'Độ dài tối thiểu 6 ký tự',
  maxLength30Message: 'Độ dài không vượt quá 30 ký tự',
  likePassword: 'Mật khẩu không trùng nhau'
};
export const messageToast = {
  messageToastReportExcelSuccess: 'Xuất dữ liệu thành công',
  messageToastReportExcelError: 'Xuất dữ liệu không thành công',
  messageToastDeleteSuccess: 'Xóa dữ liệu thành công',
  messageToastCreateSuccess: 'Thêm mới dữ liệu thành công',
  messageToastUpdateSuccess: 'Cập nhật dữ liệu thành công',
  messageToastDeleteError: 'Xóa dữ liệu không thành công',
  messageToastCreateError: 'Thêm mới dữ liệu không thành công',
  messageToastUpdateError: 'Cập nhật dữ liệu không thành công',
  messageToastTryCatch: 'Gặp lỗi khi thực hiện thao tác, vui lòng thử lại!',
  messageToastChangePassSuccess: 'Đổi mật khẩu thành công',
  messageToastChooseDateError: 'Mời chọn ngày',
  messageToastRecoverPassSuccess: 'Mật khẩu đã được cập nhât, xin mời đăng nhập lại',
  messageToastImportExcelSuccess: 'Dữ liệu excel import thành công',
  messageToastSendEmailSuccess: 'Gửi email thành công',
  messageToastImportExcelErrorLackIdDepartment: 'Dữ liệu excel import thất bại, không tìm được Id của khoa: ',
  messageToastImportExcelErrorLackIdAccount: 'Dữ liệu excel import thất bại, không tìm được Id của tài khoản: '
};

export const dataTypeComponent = [
  { label: 'html', value: 'html' },
  { label: 'ảnh', value: 'image' },
  { label: 'video', value: 'video' },
  { label: 'text', value: 'text' },
  { label: 'nâng cao', value: 'model' }
];

export const styleSelectError = {
  control: (base) => ({
    ...base,
    border: '1px solid #dc3545',
    boxShadow: 'none'
  })
};

export const styleSelectDefault = {
  control: (base) => ({
    ...base
  })
};

export const rangeDate = {
  'Hôm nay': [moment().toDate(), moment().toDate()],
  'Hôm qua': [
    moment().subtract(1, 'days').toDate(),
    moment().subtract(1, 'days').toDate()
  ],
  '7 ngày trước': [moment().subtract(6, 'days').toDate(), moment().toDate()],
  '30 ngày trước': [moment().subtract(29, 'days').toDate(), moment().toDate()],
  'Tháng này': [
    moment().startOf('month').toDate(),
    moment().endOf('month').toDate()
  ],
  'Tháng trước': [
    moment().subtract(1, 'month').startOf('month').toDate(),
    moment().subtract(1, 'month').endOf('month').toDate()
  ]
};
export const rangeDateBooking = {
  'Hôm nay': [moment().toDate(), moment().toDate()],
  'Ngày mai': [
    moment().add(1, 'days').toDate(),
    moment().add(1, 'days').toDate()
  ],
  '7 ngày sau': [moment().toDate(), moment().add(6, 'days').toDate()],
  '30 ngày sau': [moment().toDate(), moment().add(29, 'days').toDate()],
  'Tháng này': [
    moment().startOf('month').toDate(),
    moment().endOf('month').toDate()
  ],
  'Tháng sau': [
    moment().add(1, 'month').startOf('month').toDate(),
    moment().add(1, 'month').endOf('month').toDate()
  ]
};
export const rangeDateReport = {
  'Hôm nay': [moment().startOf('day').toDate(), moment().endOf('day').toDate()],
  'Hôm qua': [
    moment().subtract(1, 'days').startOf('day').toDate(),
    moment().subtract(1, 'days').endOf('day').toDate()
  ],
  '7 ngày trước': [moment().subtract(6, 'days').startOf('day').toDate(), moment().endOf('day').toDate()],
  '30 ngày trước': [moment().subtract(29, 'days').startOf('day').toDate(), moment().endOf('day').toDate()],
  'Tháng này': [
    moment().startOf('month').toDate(),
    moment().endOf('month').toDate()
  ],
  'Tháng trước': [
    moment().subtract(1, 'month').startOf('month').toDate(),
    moment().subtract(1, 'month').endOf('month').toDate()
  ],
  '3 tháng trước': [
    moment().subtract(3, 'months').startOf('month').toDate(),
    moment().endOf('day').toDate()
  ],
  '6 tháng trước': [
    moment().subtract(6, 'months').startOf('month').toDate(),
    moment().endOf('day').toDate()
  ],
  'Năm': [
    moment().startOf('year').toDate(),
    moment().endOf('year').toDate()
  ]
};
export const rangeDateDashboard = {
  // 'Hôm nay': [moment().startOf('day').toDate(), moment().endOf('day').toDate()],
  // 'Hôm qua': [
  //   moment().subtract(1, 'days').startOf('day').toDate(),
  //   moment().subtract(1, 'days').endOf('day').toDate()
  // ],
  '7 ngày trước': [moment().subtract(6, 'days').startOf('day').toDate(), moment().endOf('day').toDate()],
  '30 ngày trước': [moment().subtract(29, 'days').startOf('day').toDate(), moment().endOf('day').toDate()],
  'Tháng này': [
    moment().startOf('month').toDate(),
    moment().endOf('month').toDate()
  ],
  'Tháng trước': [
    moment().subtract(1, 'month').startOf('month').toDate(),
    moment().subtract(1, 'month').endOf('month').toDate()
  ],
  '3 tháng trước': [
    moment().subtract(3, 'months').startOf('month').toDate(),
    moment().endOf('day').toDate()
  ],
  '6 tháng trước': [
    moment().subtract(6, 'months').startOf('month').toDate(),
    moment().endOf('day').toDate()
  ],
  'Năm': [
    moment().startOf('year').toDate(),
    moment().endOf('year').toDate()
  ]
};
export const rangeDateDashboardNotHaveDate = {
  // 'Hôm nay': [moment().startOf('day').toDate(), moment().endOf('day').toDate()],
  // 'Hôm qua': [
  //   moment().subtract(1, 'days').startOf('day').toDate(),
  //   moment().subtract(1, 'days').endOf('day').toDate()
  // ],
  '3 tháng trước': [
    moment().subtract(3, 'months').startOf('month').toDate(),
    moment().endOf('day').toDate()
  ],
  '6 tháng trước': [
    moment().subtract(6, 'months').startOf('month').toDate(),
    moment().endOf('day').toDate()
  ],
  'Năm': [
    moment().startOf('year').toDate(),
    moment().endOf('year').toDate()
  ]
};
export const validInput = (type, value, isCheckSpace = false) => {
  if (
    type.toLowerCase() === 'text' ||
    type.toLowerCase() === 'option' ||
    type.toLowerCase() === 'tagselect' ||
    type.toLowerCase() === 'file'
  ) {
    if (isCheckSpace) {
      if (value.length === 0 || value.includes(' ')) {
        return false;
      }
    } else {
      if (value == null || value.length === 0) {
        return false;
      }
    }
    return true;
    // let regexp = /([^\s])/;
    // let checkingResult = regexp.exec(text);
    // return checkingResult !== null ? true : false;
  }
  if (type.toLowerCase() === 'number') {
    if (value == null || value.length === 0 || value === 0) {
      return false;
    }
    return true;
  }
  if (type.toLowerCase() === 'password') {
    let regexp = /^(?=.{8,})/;
    // let regexp = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    let checkingResult = regexp.exec(value);
    return checkingResult !== null ? true : false;
  }
  if (type.toLowerCase() === 'notspace') {
    let regexp = /^(\w+\S+)$/;
    let checkingResult = regexp.exec(value);
    return checkingResult !== null ? true : false;
  }

  if (type.toLowerCase() === 'phone') {
    let regexp = /^\+?\d+$/;
    try {
      if (regexp.test(value)) {
        const phoneNumber = parsePhoneNumberFromString(
          `Phone: ${parseInt(value)}`,
          'VN',
        );
        if (phoneNumber !== undefined && phoneNumber.isValid()) {
          return true;
        }
        return false;
      } else {
        return false;
      }
    } catch (e) {
      console.error('e', e);
    }

    // let regexp = /^([0|\+[0-9]{1,5})?([0-9]{10,12})$/;
    // let checkingResult = regexp.exec(text);
    // return checkingResult !== null ? true : false;
  }
  if (type.toLowerCase() === 'email') {
    var pattern =
      /^([a-zA-Z0-9_.-])+@([a-zA-Z0-9_.-])+\.([a-zA-Z])+([a-zA-Z])+/;
    return pattern.test(value);
  }
  return true;
};
